import stateUi from '@state/ui';
import Select from '@components/Select';
import * as React from 'react';
import { AlignRight, Divider, IconRow, InfoColumn, Title } from './_styles';
import { getSelectedNode } from '@src/utils';
const DefaultValue = 'Default';
const changeState = (componentState) => {
    if (componentState === DefaultValue) {
        stateUi.stateManager = null;
        return;
    }
    stateUi.stateManager = componentState;
};
const StateMutator = () => {
    const component = getSelectedNode();
    return (React.createElement(AlignRight, null,
        React.createElement(Divider, null),
        React.createElement(InfoColumn, null,
            React.createElement(Title, null, "State"),
            React.createElement(IconRow, null,
                React.createElement(Select, { value: stateUi.stateManager, placeholder: "Default", onChange: changeState, options: [DefaultValue].concat(Object.keys(component.states)) })))));
};
export default StateMutator;
